import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/custom-report/custom-report.constants";
import { DeleteCustomReportRequest, DeleteCustomReportResponse, SaveCustomReportRequest, GetCustomReportResponse } from "../../models/custom-reports/custom-reports.models";

@autoinject()
export class CustomReportService {

    constructor(private requestClient: RequestClientService) { }

    public getCustomReport(id: number): Promise<GetCustomReportResponse> {
        return this.requestClient.get(Urls.GetCustomReport, { id });
    }

    public saveCustomReport(request: SaveCustomReportRequest): Promise<any> {
        return this.requestClient.post(Urls.SaveCustomReport, {}, request);
    }

    public deleteCustomReports(request: DeleteCustomReportRequest): Promise<DeleteCustomReportResponse> {
        return this.requestClient.post(Urls.DeleteCustomReports, {}, request);
    }

    public exportCustomReport(customReportId: number): Promise<void> {
        return this.requestClient.get(`${Urls.ExportCustomReport}/${customReportId}`, {});
    }
}